import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "edit",
  "use": "edit-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"edit\"><path d=\"M.35,23.09a.5.5,0,0,0,.6.6l6.47-1.52.12,0L1.91,16.51a.48.48,0,0,0,0,.12Z\" /><rect x=\"18.52\" y=\"1.03\" width=\"1\" height=\"8\" transform=\"translate(2.01 14.91) rotate(-44.98)\" /><rect x=\"2.84\" y=\"8.35\" width=\"17.71\" height=\"8\" transform=\"translate(-5.31 11.89) rotate(-45)\" /><path d=\"M22.9,6.8l.35-.35a2.5,2.5,0,0,0,0-3.54L21.14.79a2.5,2.5,0,0,0-3.54,0l-.35.35Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol